import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import officer from "../../assets/officer-packages.jpeg";
import cloud from "../../assets/cloud-engineer.jpg";
import software from "../../assets/software-engineer.jpg";
import designer from "../../assets/ui-designer.jpg";
import network from "../../assets/network.jpg";
import businessmen from "../../assets/business-men.jpg";
import cyber from "../../assets/cybersecurity.jpg";

const imageData = [
  {
    id: 1,
    image: cyber,
    description:
      "Become a Cybersecurity Analyst, Ethical Hacker, Security Consultant",
  },
  {
    id: 2,
    image: designer,
    description: "Graphic Designer, UI/UX Designer, Animator/Multimedia Artist",
  },
  {
    id: 3,
    image: network,
    description:
      "Network Administrator, Systems Engineer, Cloud Networking Engineer",
  },
  {
    id: 4,
    image: software,
    description:
      "Software Engineer, Full-Stack Developer, Front-End Developer, Back-End Developer",
  },
  {
    id: 5,
    image: cloud,
    description: "Cloud Engineer, DevOps Engineer, Cloud Solutions Architect",
  },
  {
    id: 6,
    image: officer,
    description:
      "Office Administrator, Database Manager, IT Support Specialist",
  },
  {
    id: 7,
    image: businessmen,
    description: "Business Analyst, Project Manager, Human Resource Manager",
  },
];

const WithJRIIT = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = 0;
    }
  }, []);

  // Auto-slide functionality
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % imageData.length;
          scrollToImage(nextIndex);
          return nextIndex;
        });
      }, 4000); // 4 seconds interval
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused]);

  const scrollToImage = (index) => {
    const container = containerRef.current;
    if (container) {
      const scrollAmount = (container.offsetWidth / 2) * index;
      container.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
    scrollToImage(index);
  };

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <section className="bg-gray-100 py-6 sm:py-12">
      {/* Adjusted text alignment for Discover JRIIT section */}
      <div className="text-left mb-6 sm:mb-10 max-w-6xl mx-auto px-4 sm:px-8">
        <h2 className="text-2xl sm:text-3xl text-custom-pink font-bold mb-4 tracking-wide">
          Discover JRIIT
        </h2>
        <p className="text-base sm:text-lg leading-relaxed tracking-wide text-justify">
          At JRIIT, students turn knowledge into practical skills through
          independent projects, immersive hands-on learning, and expert-led
          experiential opportunities across various IT fields. Engage with
          experts, collaborate with peers, and build innovative solutions
          through our world-class programs and facilities. Whether you're
          looking to expand your technical expertise or start a new venture,
          JRIIT offers pathways to success in a rapidly evolving IT landscape.
        </p>
      </div>

      {/* Layout for With JRIIT you can */}
      <div className="flex flex-col sm:flex-row justify-between items-center max-w-full mx-auto pl-4 sm:pl-8 mr-0 pr-0">
        <div className="flex flex-col items-center space-y-6 p-20 mb-6 sm:mb-0">
          <h3 className="text-lg font-bold whitespace-nowrap text-custom-pink tracking-wide">
            With JRIIT you can:
          </h3>

          {/* Dots Navigation */}
          <div className="flex space-x-2">
            {imageData.map((_, index) => (
              <button
                key={index}
                onClick={() => handleDotClick(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 hover:scale-110 ${index === currentIndex
                    ? "bg-custom-pink shadow-lg"
                    : "bg-gray-300 hover:bg-gray-400"
                  }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Image slider with responsive visible images and a gray border on the left */}
        <div
          className="relative w-full sm:w-3/4 overflow-x-auto hide-scrollbar border-l-2 border-gray-300 pl-4 sm:pl-56 mr"
          ref={containerRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{ scrollSnapType: "x mandatory" }}
        >
          <div className="flex w-full sm:w-[200%] md:w-[150%]">
            {imageData.map((item, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 p-2 sm:p-4"
                style={{ scrollSnapAlign: "center" }}
              >
                <div className="bg-white rounded-lg shadow-md overflow-hidden w-full max-w-[650px] transition-transform duration-300 hover:shadow-xl hover:-translate-y-1">
                  <img
                    src={item.image}
                    alt={`Slide ${index}`}
                    className="w-full h-[200px] sm:h-[300px] md:h-[440px] object-cover"
                  />
                  <div className="p-4 text-left">
                    <p className="mt-2 text-black text-sm sm:text-base tracking-wide">
                      {item.description}
                    </p>
                    <div className="mt-4 flex justify-between">
                      <Link to="/programs" className="bg-custom-pink text-white px-3 py-1 sm:px-4 sm:py-2 text-sm sm:text-base rounded hover:bg-gold transition-colors duration-300">
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WithJRIIT;
